import React, { createContext, useContext, ReactNode } from 'react';
import { Category } from '@/api/types/categories.types';

interface NewAdContextProps {
  categories: Category[];
  rootCategory?: Category | null;
  selectedCategory?: Category | null;
  defaultSubcategory?: Category | null;
  selectedSubcategory?: Category | null;
  setSelectedCategory: (category: Category | null) => void;
  setSelectedSubcategory: (category: Category | null) => void;
}

const NewAdContext = createContext<NewAdContextProps | undefined>(undefined);

export const NewAdContextProvider = ({
  children,
  categories,
  selectedCategory,
  defaultSubcategory,
  selectedSubcategory,
  setSelectedCategory,
  setSelectedSubcategory,
}: {
  children: ReactNode;
  categories: Category[];
  selectedCategory?: Category | null;
  defaultSubcategory?: Category | null;
  selectedSubcategory?: Category | null;
  setSelectedCategory: (category: Category | null) => void;
  setSelectedSubcategory: (category: Category | null) => void;
}) => {
  const rootCategory = categories[0]?.parent;

  return (
    <NewAdContext.Provider
      value={{
        categories,
        rootCategory,
        selectedCategory,
        defaultSubcategory,
        selectedSubcategory,
        setSelectedCategory,
        setSelectedSubcategory,
      }}
    >
      {children}
    </NewAdContext.Provider>
  );
};

export const useNewAdContext = () => {
  const context = useContext(NewAdContext);
  if (!context) {
    throw new Error('useNewAdContext must be used within NewAdContextProvider');
  }
  return context;
};
